const pirfix = 'SPOT_FE_DEPOSIT_EARN_';

export const ConstantCacheKeys = {

  /**
   * /spot/api/deposit-activity/v1/project/home
   */
  HOME: pirfix + 'HOME',

  /**
   * /spot/api/deposit-activity/v2/project/end/projectList
   */
  END_PROJECT_LIST: pirfix + 'END_PROJECT_LIST',

  /**
   * /spot/api/deposit-activity/v2/project/ongoing/projectList
   */
  ONGOING_PROJECT_LIST: pirfix + 'ONGOING_PROJECT_LIST',

  /**
   * /spot/api/deposit-activity/v2/project/detail
   */
  PROJECT_DETAIL: pirfix + 'PROJECT_DETAIL',

  /**
   * /spot/api/deposit-activity/v2/project/userProject
   */
  USER_PROJECT: pirfix + 'USER_PROJECT',
};

